import { type StateCreator } from 'zustand';
import { LifestyleCategory } from '@ev-tech/search-modules-api';

import { type MiddlewareType, type SearchStore } from '../SearchStoreProvider';

const initialLifestyleCategoryState: Record<LifestyleCategory, boolean> = {
  [LifestyleCategory.WATERFRONT]: false,
  [LifestyleCategory.MOUNTAIN]: false,
  [LifestyleCategory.CASTLE_MANORHOUSES]: false,
  [LifestyleCategory.RANCH]: false,
  [LifestyleCategory.PENTHOUSE]: false,
  [LifestyleCategory.GOLF]: false,
  [LifestyleCategory.SKI]: false,
  [LifestyleCategory.VINEYARDS_WINERIES]: false,
  [LifestyleCategory.EQUESTRIAN]: false,
} as const;

export type LifestyleCategoryState = {
  lifestyleCategories: Record<LifestyleCategory, boolean>;
};

type LifestyleCategoryActions = {
  setLifestyleCategory: (lifestyleCategory: LifestyleCategory, value: boolean) => void;
};

export type LifestyleCategoryStore = LifestyleCategoryState & LifestyleCategoryActions;

export const defaultLifestyleCategoryState: Readonly<LifestyleCategoryState> = {
  lifestyleCategories: initialLifestyleCategoryState,
};

export const createLifestyleCategorySlice: StateCreator<SearchStore, MiddlewareType, [], LifestyleCategoryStore> = (set) => ({
  ...defaultLifestyleCategoryState,
  setLifestyleCategory: (lifestyleCategory: LifestyleCategory, value: boolean) => {
    set(
      (state) => {
        state.lifestyleCategories[lifestyleCategory] = value;
        state.page = 1;
      },
      undefined,
      'setLifestyleCategory',
    );
  },
});
